<template>
  <div :class="classes" :style="styles">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FlexColumn',
  props: {
    space: {
      type: [Number, String],
      default: 1,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: undefined,
    },
    center: {
      type: Boolean,
      default: false,
    },
    noWrap: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    classes() {
      const list = [
        'd-flex',
        'flex-column',
        `space-${this.space}`,
      ]
      if (!this.noWrap) list.push('flex-wrap')
      if (this.fullWidth) list.push('full-width')
      if (this.center) list.push('align-center')
      return list
    },
    styles() {
      return {
        width: this.width,
      }
    },
  },
}
</script>

<style scoped>
.flex-column.space-half > *:not(:last-child) {
  margin-bottom: 4px;
}
.flex-column.space-1 > *:not(:last-child) {
  margin-bottom: 8px;
}
.flex-column.space-2 > *:not(:last-child) {
  margin-bottom: 16px;
}
.flex-column.space-3 > *:not(:last-child) {
  margin-bottom: 24px;
}
.flex-column.space-4 > *:not(:last-child) {
  margin-bottom: 32px;
}
.flex-column.space-5 > *:not(:last-child) {
  margin-bottom: 40px;
}
.flex-column.space-6 > *:not(:last-child) {
  margin-bottom: 48px;
}
.full-width {
  flex-grow: 1;
}
</style>
